export const COLORS = {
  ERROR: '#ffdede',
  TEXT_ERROR: '#ff9595',
};
